"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionService = void 0;
class VersionService {
    constructor() {
        this.myValue = {
            applicationVersion: "",
            biddrPlusVersion: "",
            allBiddrPlusVersions: [],
            controlCenterVersion: "",
            allControlCenterVersions: [],
        };
        this.loginURL = "/login";
    }
    pull() {
        this.myValue.applicationVersion = "4.57.0";
        this.myValue.biddrPlusVersion = "9.0.0";
        this.myValue.allBiddrPlusVersions = [
            "9999",
            "9.0.0",
            "8.1.0",
            "8.0.0",
            "7.0.0",
            "6.3.0",
            "6.2.0",
            "6.1.0",
            "6.0.0",
            "5.1.0",
            "4.5.0",
            "4.4.0",
            "4.2.1",
            "4.2.0",
            "4.1.2",
            "4.1.1",
            "4.0.4",
            "4.0.3",
            "4.0.2",
            "4.0.1",
            "4.0.0",
        ];
        this.myValue.controlCenterVersion = "";
        this.myValue.allControlCenterVersions = [];
    }
    getControlCenterVersion() {
        return this.myValue.controlCenterVersion;
    }
    getApplicationVersion() {
        return this.myValue.applicationVersion;
    }
    getAllBiddrPlusVersions() {
        return this.myValue.allBiddrPlusVersions;
    }
    getBiddrPlusVersion() {
        return this.myValue.biddrPlusVersion;
    }
    getAllControlCenterVersions() {
        return this.myValue.allControlCenterVersions;
    }
}
exports.VersionService = VersionService;
//# sourceMappingURL=version.service.js.map